var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0H0.5C0.224 0 0 0.224 0 0.5V9.5C0 9.776 0.224 10 0.5 10H10.5C10.776 10 11 9.776 11 9.5V0.5C11 0.224 10.776 0 10.5 0ZM23.5 0H13.5C13.224 0 13 0.224 13 0.5V9.5C13 9.776 13.224 10 13.5 10H23.5C23.776 10 24 9.776 24 9.5V0.5C24 0.224 23.776 0 23.5 0ZM10.5 12H0.5C0.224 12 0 12.224 0 12.5V21.5C0 21.776 0.224 22 0.5 22H10.5C10.776 22 11 21.776 11 21.5V12.5C11 12.224 10.776 12 10.5 12ZM23.5 12H13.5C13.224 12 13 12.224 13 12.5V21.5C13 21.776 13.224 22 13.5 22H23.5C23.776 22 24 21.776 24 21.5V12.5C24 12.224 23.776 12 23.5 12Z",
    fill: "#151515",
    className: "hc-icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.d28ec3d77aa4a753475a73523a2db751.svg";
export { ForwardRef as ReactComponent };